export default __webpack_public_path__ + "static/media/atencion_amarillo.bd7bec04.svg";